import http, {download} from "../../../utils/HttpUtils";

//仓库接口服务
class WarehouseService {
    //新建仓库
    static async insert(data) {
        const apiUrl = "/base/warehouse/insert";
        return await http.post(apiUrl, data);
    }

    //修改仓库
    static async update(data) {
        const apiUrl = "/base/warehouse/update";
        return await http.post(apiUrl, data);
    }

    //根据ID查询仓库信息
    static async findOne(id) {
        const apiUrl = `/warehouse/find/${id}`;
        return await http.get(apiUrl);
    }

    //分页查询仓库信息
    static async findPage(data) {
        const apiUrl = "/base/warehouse/findPage";
        return await http.post(apiUrl, data);
    }

    //根据ID删除仓库信息
    static async deleteOne(id) {
        const apiUrl = `/whWarehouse/deleteById/${id}`;
        return await http.post(apiUrl);
    }
    //导出数据
    static async export() {
        const apiUrl = "/whWarehouse/export";
        await download(apiUrl)
    }
    //下载数据
    static async downloadTpl() {
        const apiUrl = "/whWarehouse/downloadTpl";
        await download(apiUrl)
    }
    //获取ID
    static async generateID() {
        const apiUrl = "/whWarehouse/generateID";
        return await http.get(apiUrl);
    }
}

export default WarehouseService;
